/**
 * Created by zad on 17/1/12.
 */
import Loading from './Loading';

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js